import React, { useState, FC } from 'react';
import { motion } from 'framer-motion';
import ComparePlansAccordionStyled from './ComparePlansAccordionStyled';
import { OrderPageConfigMetadata } from '~/types/order';
import { IconChevronRight, IconChevronUp } from '@red-digital/bricks';

interface Props {
  className?: string;
  title: JSX.Element | string;
  activeIndex: number;
  children: JSX.Element[] | JSX.Element | string;
  metadata?: OrderPageConfigMetadata;
}

const ComparePlansAccordion: FC<Props> = ({ title, children, activeIndex, metadata, ...props }) => {
  const [active, setActive] = useState(true);
  const handleCollapse = (e: { key: string }) => {
    if (e.key === 'Enter') {
      setActive(!active);
    }
  };

  return (
    <ComparePlansAccordionStyled active={active} activeIndex={activeIndex} {...props} metadata={metadata}>
      <div className="accordion__wrapper">
        <header
          className="accordion__header"
          tabIndex={activeIndex}
          role="button"
          onKeyDown={handleCollapse}
          onClick={() => setActive(!active)}
        >
          <div className="accordion__title-container">
            <span className="accordion__title">{title}</span>
            {active ? <IconChevronUp className="accordion__icon" /> : <IconChevronRight className="accordion__icon" />}
          </div>
        </header>
        <motion.section
          className="accordion__content"
          initial={active ? 'active' : 'inactive'}
          animate={active ? 'active' : 'inactive'}
          exit="inactive"
          variants={{
            active: { opacity: 1, height: 'auto' },
            inactive: { opacity: 0, height: 0 },
          }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          {children}
        </motion.section>
      </div>
    </ComparePlansAccordionStyled>
  );
};

ComparePlansAccordion.displayName = 'ComparePlansAccordion';

export default ComparePlansAccordion;
